import { Context, useContext } from 'react';

export const useRequiredContext = <T>(
  context: Context<T>,
  hookName: string,
  providerName: string
): NonNullable<T> => {
  const value = useContext(context);
  if (value === null || value === undefined) {
    throw new Error(`${hookName} must be called inside <${providerName}>.`);
  }
  return value;
};
